import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';
import VueCookies from 'vue-cookies';
import users from './modules/users';
import contents from './modules/contents';
import settings from './modules/settings';
import sales from './modules/sales';
import device from './modules/device';
import subscriptions from './modules/subscriptions';
import classroom from './modules/classroom';
import baseState from './base_state';
import information from './modules/information';
import persisted from './modules/persisted';

Vue.use(VueCookies);
Vue.use(Vuex);
window.getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

function isValid(params) {
  if (!params || params === 'undefined' || params === 'null' || params === '') {
    return false;
  }
  return true;
}

const debug = process.env.NODE_ENV !== 'production';
const store = new Vuex.Store({
  state: baseState,
  mutations: {
    storeToken(state, token) {
      state.authToken = token;
      window.$cookies.set('x-token', token, null, null, '.xeropan.com');
    },
    storeProfileUser(state, user) {
      state.loggedInUserProfile = {
        ...state.loggedInUserProfile,
        ...user,
      };
    },
    removeApiTokenFromCookie() {
      window.$cookies.set('api-token', undefined, null, null, '.xeropan.com');
      document.cookie =
        'api-token=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.xeropan.com;path=/';
    },
    removeXTokenFromCookie() {
      window.$cookies.set('x-token', undefined, null, null, '.xeropan.com');
      document.cookie =
        'x-token=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.xeropan.com;path=/';

      // kreta JWT token
      document.cookie =
        'dkt-jwt-token=;expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; HostOnly; domain=.xeropan.com; path=/';
    },
    storeUserStatus(state, status) {
      state.registrationStatus = status;
    },
    SET_USER_LANGUAGE_OVERWRITE(state, value) {
      state.userOverwriteBrowserLanguage = value;
    },
  },
  getters: {
    hasToken: (state) => {
      let cookieToken;
      cookieToken = window.$cookies.get('x-token');
      if (
        cookieToken == 'undefined' ||
        cookieToken == '' ||
        cookieToken == undefined
      ) {
        cookieToken = undefined;
        window.$cookies.remove('x-token');
      }
      return (
        (state.authToken !== undefined &&
          state.authToken !== 'undefined' &&
          state.authToken !== null &&
          state.authToken !== '' &&
          state.authToken !== ' ') ||
        cookieToken != null
      );
    },
    registrationStatus: state => state.registrationStatus,
    getAuthToken: (state) => {
      let authTokenVar = window.$cookies.get('x-token');
      if (!isValid(authTokenVar)) {
        authTokenVar = state.authToken;
        if (!isValid(authTokenVar)) {
          authTokenVar = state.users.loggedInUserProfile.user.token;
        }
      }
      if (isValid(authTokenVar) && !isValid(state.authToken)) {
        state.authToken = authTokenVar;
      }
      return authTokenVar;
    },
    getUserOverwriteBrowserLanguage: state =>
      state.userOverwriteBrowserLanguage,
  },
  modules: {
    users,
    contents,
    settings,
    sales,
    device,
    subscriptions,
    information,
    classroom,
    persisted,
  },
  strict: debug,
  plugins: [
    persistedState({
      key: 'store',
      paths: [
        'classroom.joiningOptions',
        'classroom.studentClasses',
        'classroom.allOpenAssignments',
        'getFirstTimePermission',
        'authToken',
        'registrationStatus',
        'contents.currentlyLoadedIslandWhereUserWas',
        'settings',
        'sales',
        'information',
        'users.loggedInUserProfile',
        'device',
        'persisted',
      ],
    }),
  ],
});

export default store;
